// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"8024861a","2083":"8024861a","3342":"8024861a","5981":"8024861a","7313":"8024861a"}[chunkId] + ".chunk.css";
};